"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Amount = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ticker = require("../../../ticker");
var _utils = require("../../../../utils");
var _fonts = require("../../fonts");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TertiaryShadeText = (0, _styledComponents.default)(_fonts.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var H6 = (0, _styledComponents.default)(_fonts.H6)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  margin-bottom: 5px;\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
    $color = _ref2.$color;
  return theme.colors[$color !== null && $color !== void 0 ? $color : 'tertiary'];
});
var Wrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), _utils.mediaQuery.lessThan('lg')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  "]))));
var Amount = function Amount(_ref3) {
  var Value = _ref3.value,
    ConvertedValue = _ref3.convertedValue,
    convertedTicker = _ref3.convertedTicker,
    ticker = _ref3.ticker,
    positive = _ref3.positive;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(H6, {
    $color: positive === undefined ? undefined : positive ? 'success' : 'danger'
  }, positive !== undefined && (!positive ? '-' : '+'), typeof Value !== 'number' && typeof Value !== 'string' ? /*#__PURE__*/_react.default.createElement(Value, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: Value,
    ticker: ticker
  }), " ", ticker)), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, typeof ConvertedValue !== 'string' && typeof ConvertedValue !== 'number' ? /*#__PURE__*/_react.default.createElement(ConvertedValue, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "(", convertedTicker === _definitions.Ticker.USD && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: convertedTicker
  }), ' '), /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: ConvertedValue,
    ticker: convertedTicker
  }), convertedTicker !== _definitions.Ticker.USD && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", convertedTicker), ")")));
};
exports.Amount = Amount;